  <base-modal>
    <div modal-header>
      <button type="button" (click)="exitModal.emit()" class="close" aria-label="Close" data-testid="7CFE148C-7103-46D9-880D-E878395E7541">
        <span>×</span>
      </button>
      <h4 id="confirmation_title" class="modal-title"><i class="fa fa-user-check fa-light"></i>New Attendee Confirmation</h4>
    </div>
    <div modal-body>
      <div class="confirmation-modal">
        <div class="instructions">
          Please confirm the following attendee should be added to this events roster. Their attendance will be verified as part of this process.
        </div>
        <div class="entity-detail user">
          <h4 class="name">
            <span class="item-id labeled">{{registryLabel}}<span class="number">{{attendee.appId||"N/A"}}</span></span>
            {{attendee.firstName}} {{attendee.lastName}}
          </h4>
          <ul class="styled-list title-list">
            <li>
              <span class="info">
                <i class="fa fa-light fa-envelope" aria-hidden="true"></i>
                Email<span>
                  {{attendee.email||"N/A"}}
                </span>
              </span>
            </li>
            <!--Paid Status-->
            <li *ngIf="hasPaid!==undefined && hasPaid">
              <span class="info">
                <i class="fa fa-light fa-file-invoice-dollar" aria-hidden="true"></i>Payment Status<span><i class="fa fa-circle-check success-status" aria-hidden="true"></i>Paid</span>
              </span>
            </li>
            <!--Unpaid Status-->
            <li *ngIf="hasPaid!==undefined && !hasPaid">
              <span class="info">
                <i class="fa fa-light fa-file-invoice-dollar" aria-hidden="true"></i>Payment Status<span><i class="fa fa-triangle-exclamation warning-status" aria-hidden="true"></i>Unpaid</span>
              </span>
            </li>
          </ul>
        </div>

      </div>
      <div *ngIf="attendeeTypesExists">
        <label for="attendee_type">
          Please Select an Attendee Type
        </label>
        <select id="attendee_type" class="form-control input-lg" [(ngModel)]="selectedAttendeeType" data-testid="32C9D713-BF52-4543-9E86-5F1A3AE78FA4">
          <option [ngValue]="undefined" disabled selected>Select an Attendee Type</option>
          <option *ngFor="let type of attendeeTypes" [ngValue]="type">{{type.attendeeTypeName}}</option>
        </select>
      </div>
    </div>
    
    
   
    <div modal-footer>
      <div class="row">
        <div class="twobutton-col">
          <button type="button" role="button" [disabled]="attendeeTypeNotSelected" data-dismiss="modal" class="btn primary-btn btn-lg add-confirm-manual" (click)="onConfirmClick()" data-testid="0AFC6DF8-3A39-49C3-AD8E-6E4660A3B186">Add Attendee</button>
        </div>
        <div class="twobutton-col">
          <button role="button" type="button" data-dismiss="modal" class="btn btn-gray btn-lg" (click)="exitModal.emit()" data-testid="B4797BFC-D770-46C4-ABE3-37CB6470D0FF">Cancel</button>
        </div>
      </div>
    </div>
  </base-modal>

